import React from "react";
import './index.css';
import './tailwind.css';
import {Header} from "./components/Header";
import Hero from "./components/Hero";
import Servicios from "./components/Servicios";
import Nosotros from "./components/Nosotros";
import Contacto from "./components/Contacto";
import Footer from "./components/Footer";
import FloatingButton from "./components/FloatingMenu";

function App() {
  return (
    <div className="min-h-screen bg-gray-50 text-gray-800">
      <Header />
      <Hero />
      <Servicios />
      <Nosotros />
      <Contacto />
      <Footer />
      <FloatingButton />
    </div>
  );
}

export default App;

